<div
  class="row upload-zone subtitles"
  [class.drag]="dragState.subtitles"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter('subtitles')"
  (dragleave)="onDragLeave('subtitles')"
  (drop)="onDrop($event, 'subtitles')"
>
  <div class="label">
    <i inlineSVG="/assets/icons/subtitles.svg"></i>
    <span>Subtitles:</span>
  </div>
  <label>
    <input
      type="file"
      hidden
      (change)="onInputFileChange($event, 'subtitles')"
      accept=".srt,.sub,.wsrt,.xml,.ass,.aqt,.stp,.detx,.cac,
               .crk,.csv,.stl,.edl,.fcpxml,.ttxt,.gst,.ats,.itt,.dfxp,
               .ttml,.json,.lrc,.imtpro,.mpl,.lrc,.pjs,.caption,.rt,.smi,
               .scc,.ssa,.sif,.tek,.tt,.subtitle,.xsubtitle,.trs,.tmx,.tts,
               .usf,.utx,.vtt,.xif,.sbv,.zeg,.titl,.cip,.pst,.cap,.pac,.890,
               .spt,.wsb,.chk,.cin,.ult,.elr,.uld,.sup,.dost,.aya,.fpc,.son,.ooona"
    />
    <span
      class="upload-button"
      inlineSVG="/assets/icons/upload-icon.svg"
    ></span>
  </label>
  <icn-file-label
    *ngFor="let subtitle of media?.subtitles"
    [label]="subtitle.language"
    (remove)="removeSubtitle(subtitle)"
    (settingsClick)="onSubtitleSettingsClick($event, subtitle)"
  ></icn-file-label>
  <icn-file-analyze
    *ngFor="let subtitle of uploadedSubtitles"
    [text]="subtitle"
    [canRemove]="false"
  >
  </icn-file-analyze>
  <pop-over
    #subtitlesLanguagePopover
    [my]="'bottom right'"
    [at]="'top right'"
    [anchor-to]="true"
    [x-offset]="-200"
  >
    <div class="langPopover">
      <h1>Subtitles Language</h1>
      <div class="lang-flex-container">
        <div class="lang-container">
          <label>ASSIGN LANGUAGE:</label>
          <icn-dropdown
            *ngIf="!!subtitleFileChosen"
            [position]="bottom"
            [selectedValue]="subtitleFileChosen.language"
            (selectedValueChange)="onSubtitlesSelectedValueChange($event)"
          >
            <icn-dropdown-item
              *ngFor="let lang of languages"
              [title]="lang.name"
              [value]="lang.code"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
        <div class="fps-container">
          <label>FPS:</label>
          <icn-dropdown
            *ngIf="!!subtitleFileChosen"
            [position]="bottom"
            [(selectedValue)]="subtitleFileChosen.fps"
            [defaultValue]="-1"
          >
            <icn-dropdown-item title="None" [value]="-1"></icn-dropdown-item>
            <icn-dropdown-item
              title="23.976"
              [value]="23.976"
            ></icn-dropdown-item>
            <icn-dropdown-item title="24" [value]="24"></icn-dropdown-item>
            <icn-dropdown-item
              title="25 - Default for Israel & Europe"
              [value]="25"
            ></icn-dropdown-item>
            <icn-dropdown-item
              title="29.97"
              [value]="29.97"
            ></icn-dropdown-item>
            <icn-dropdown-item
              title="30 - Default for the US & Japan"
              [value]="30"
            ></icn-dropdown-item>
            <icn-dropdown-item title="50" [value]="50"></icn-dropdown-item>
            <icn-dropdown-item
              title="59.94"
              [value]="59.94"
            ></icn-dropdown-item>
            <icn-dropdown-item title="60" [value]="60"></icn-dropdown-item>
          </icn-dropdown>
        </div>
      </div>
      <div>
        <a
          *ngIf="!!subtitleFileChosen && !!subtitleFileChosen.signedUrl"
          download="{{ subtitleFileChosen.fileName }}"
          href="{{ subtitleFileChosen.signedUrl }}"
          >Download</a
        >
      </div>
    </div>
  </pop-over>
</div>

<div class="row upload-zone closed-captions">
  <div class="label">
    <i inlineSVG="/assets/icons/closed-captions.svg"></i>
    <span>Closed Captions:</span>
  </div>
  <input
    #closedCaptionInput
    type="file"
    hidden
    accept=".scc"
    (change)="onInputFileChange($event, 'closedCaptions')"
  />
  <span
    class="upload-button"
    inlineSVG="/assets/icons/upload-icon.svg"
    (click)="onUploadClosedCaption()"
  ></span>
  <icn-file-label
    *ngFor="let caption of media?.closedCaptions"
    [label]="caption.flavoredLabel"
    (remove)="removeClosedCaption(caption)"
    (settingsClick)="onClosedCaptionSettingsClick($event, caption)"
  ></icn-file-label>
  <icn-file-analyze
    *ngFor="let caption of uploadedClosedCaptions"
    [text]="caption"
    [canRemove]="false"
  ></icn-file-analyze>
  <span
    *ngIf="!media?.closedCaptions?.length && !uploadedClosedCaptions?.length"
    class="empty-hint"
    >None</span
  >
  <pop-over
    #closedCaptionsLanguagePopover
    [my]="'bottom right'"
    [at]="'top right'"
    [anchor-to]="true"
    [x-offset]="-200"
  >
    <div class="langPopover">
      <h1>{{ closedCaptionFileChosen?.flavoredLabel }} Closed Captions</h1>
      <div class="lang-flex-container">
        <div class="lang-container">
          <label>ASSIGN LANGUAGE:</label>
          <icn-dropdown
            *ngIf="!!closedCaptionFileChosen"
            [position]="bottom"
            [selectedValue]="closedCaptionFileChosen.language"
            (selectedValueChange)="onClosedCaptionsSelectedValueChange($event)"
          >
            <icn-dropdown-item
              *ngFor="let lang of languages"
              [title]="lang.name"
              [value]="lang.code"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
        <!--<div class="fps-container">
          <label>FPS:</label>
          <icn-dropdown
            *ngIf="!!closedCaptionFileChosen"
            [position]="bottom"
            [(selectedValue)]="closedCaptionFileChosen.fps"
            [defaultValue]="-1"
          >
            <icn-dropdown-item title="None" [value]="-1"></icn-dropdown-item>
            <icn-dropdown-item
              title="23.976"
              [value]="23.976"
            ></icn-dropdown-item>
            <icn-dropdown-item title="24" [value]="24"></icn-dropdown-item>
            <icn-dropdown-item
              title="25 - Default for Israel & Europe"
              [value]="25"
            ></icn-dropdown-item>
            <icn-dropdown-item
              title="29.97"
              [value]="29.97"
            ></icn-dropdown-item>
            <icn-dropdown-item
              title="30 - Default for the US & Japan"
              [value]="30"
            ></icn-dropdown-item>
            <icn-dropdown-item title="50" [value]="50"></icn-dropdown-item>
            <icn-dropdown-item
              title="59.94"
              [value]="59.94"
            ></icn-dropdown-item>
            <icn-dropdown-item title="60" [value]="60"></icn-dropdown-item>
          </icn-dropdown>
        </div>-->
      </div>
      <div>
        <a
          *ngIf="
            !!closedCaptionFileChosen && !!closedCaptionFileChosen.originalUrl
          "
          download="{{ closedCaptionFileChosen.flavoredLabel }}.scc"
          href="{{ closedCaptionFileChosen.originalUrl }}"
          >Download SCC</a
        >
      </div>
      <div>
        <a
          *ngIf="
            !!closedCaptionFileChosen && !!closedCaptionFileChosen.signedUrl
          "
          download="{{ closedCaptionFileChosen.fileName }}"
          href="{{ closedCaptionFileChosen.signedUrl }}"
          >Download JSON</a
        >
      </div>
    </div>
  </pop-over>
</div>

<div
  class="row upload-zone audio"
  [class.drag]="dragState.audio"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter('audio')"
  (dragleave)="onDragLeave('audio')"
  (drop)="onDrop($event, 'audio')"
>
  <div class="label">
    <i inlineSVG="/assets/icons/audio.svg"></i>
    <span>Audio:</span>
  </div>
  <label>
    <input
      type="file"
      hidden
      (change)="onInputFileChange($event, 'audio')"
      accept="audio/*, .3gp, .aa, .aac, .aax, .act, .aiff, .amr, .ape, .au, .awb,
                .dct, .dss, .dvf, .flac, .gsm, .iklax, .ivs, .m4a, .m4b, .m4p, .mmf,
                .mp3, .mpc, .msv, .ogg, .oga, .mogg, .opus, .ra, .rm, .raw, .sln, .tta,
                .vox, .wav, .wma, .wv, .webm"
    />
    <span
      class="upload-button"
      inlineSVG="/assets/icons/upload-icon.svg"
    ></span>
  </label>
  <div class="files">
    <icn-file-label
      *ngFor="
        let audioFile of media ? getCompleteAudioFiles() : [];
        trackBy: trackById
      "
      [label]="audioFile.name"
      (remove)="onRemoveAudio(audioFile.id)"
      (settingsClick)="onChangeLanguage($event, audioFile)"
    >
    </icn-file-label>
    <icn-file-upload
      *ngFor="let uploadFile of audioUploadedFiles; trackBy: trackById"
      [uploadFile]="uploadFile"
      (remove)="abortAudioUpload(uploadFile)"
    ></icn-file-upload>
    <icn-file-analyze
      *ngFor="
        let audioFile of media ? getAnalyzingAudioFiles() : [];
        trackBy: trackById
      "
      (remove)="onRemoveAudio(audioFile.id)"
    ></icn-file-analyze>
  </div>
  <pop-over
    #languagePopover
    [my]="'bottom right'"
    [at]="'top right'"
    [anchor-to]="true"
    [x-offset]="-200"
  >
    <div class="langPopover">
      <h1>Audio Language</h1>
      <label>ASSIGN LANGUAGE:</label>
      <icn-dropdown
        *ngIf="!!audioFileChosen"
        [position]="bottom"
        [(selectedValue)]="audioFileChosen.language"
      >
        <icn-dropdown-item
          *ngFor="let lang of languages"
          [title]="lang.name"
          [value]="lang.code"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
  </pop-over>
</div>

<div
  class="row upload-zone packshot"
  [class.drag]="dragState.packshot"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter('packshot')"
  (dragleave)="onDragLeave('packshot')"
  (drop)="onDrop($event, 'packshot')"
>
  <div class="label">
    <i inlineSVG="/assets/icons/packshot.svg"></i>
    <span>Packshot:</span>
  </div>
  <label>
    <input
      type="file"
      hidden
      (change)="onInputFileChange($event, 'packshot')"
      accept="image/*,.jpg,.jpeg,.exif,.tiff,.tif,.gif,.bmp,.png,.ppm,.pgm,.pbm,.pnm,.webp,.rgbe,
               .heif,.bpg,.ico,.xisf"
    />
    <span
      class="upload-button"
      inlineSVG="/assets/icons/upload-icon.svg"
    ></span>
  </label>
  <icn-file-thumbnail
    *ngIf="!!media && !packshotUploaded && !media.packshotIsAnalyzed"
    [thumbnailUrl]="media.contentSnapshotUrl"
    [canRemove]="false"
  ></icn-file-thumbnail>
  <icn-file-upload
    *ngIf="!!media && !!packshotUploaded"
    [uploadFile]="packshotUploaded"
    (remove)="abortPackshotUpload()"
  ></icn-file-upload>

  <icn-file-analyze
    *ngIf="!!media && media.packshotIsAnalyzed"
    [canRemove]="false"
  ></icn-file-analyze>
</div>

<div
  class="row upload-zone trailer"
  [class.drag]="dragState.trailer"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter('trailer')"
  (dragleave)="onDragLeave('trailer')"
  (drop)="onDrop($event, 'trailer')"
>
  <div class="label">
    <i inlineSVG="/assets/icons/upload-trailer.svg"></i>
    <span>Promos:</span>
  </div>
  <label>
    <input
      type="file"
      hidden
      (change)="onInputFileChange($event, 'trailer')"
      accept="video/*,.aaf,.3gp,.gif,.asf,.avchd,.avi,.bik,.cam,.collab,.dat,.dsh,.dvr-ms,.flv,.m1v,
               .m2v,.fla,.flr,.sol,.m4v,.mkv,.wrap,.mng,.mov,.mpeg,.mpg,.mpe,.mp4,.mxf,.roq,
               .nsv,.ogg,.rm,.svi,.smi,.smk,.swf,.wmv,.wtv,.yuv,.webm"
    />
    <span
      class="upload-button"
      inlineSVG="/assets/icons/upload-icon.svg"
    ></span>
  </label>
  <icn-file-thumbnail
    *ngFor="
      let trailer of media ? getCompleteTrailerFiles() : [];
      trackBy: trackById
    "
    [thumbnailUrl]="trailer.thumbnailUrl"
    (remove)="onRemoveTrailer(trailer.id)"
  ></icn-file-thumbnail>
  <icn-file-upload
    *ngFor="let uploadFile of trailerUploadedFiles; trackBy: trackById"
    [uploadFile]="uploadFile"
    (remove)="abortTrailerUpload(uploadFile)"
  ></icn-file-upload>

  <icn-file-analyze
    *ngFor="
      let trailerFile of media ? getAnalyzingTrailerFiles() : [];
      trackBy: trackById
    "
    (remove)="onRemoveTrailer(trailerFile.id)"
  ></icn-file-analyze>
</div>
